/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";
import { DataResponse } from "services/api/AppWeb_Lead/dados-basicos";
import { Step, StepLabel } from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";
import { IoRefresh } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import DialogCommon from "components/dialogCommon";
import { EtapasModal } from "components/dialogCommon/templates/etapasModal";
import { IoIosRefresh } from "react-icons/io";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import * as Styles from "./styles";

interface Props {
  dataLead: DataResponse | undefined;
  anchorLeadCorretor?: string;
  anchorLead?: string;
  refetch: () => void;
  readOnly?: boolean;
}

export function Stepper(props: Props) {
  const [anchorEtapa, setAnchorEtapa] = useState({ label: "", value: "" });
  const [anchorSubEtapa, setAnchorSubEtapa] = useState({
    label: "",
    value: "",
  });

  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const anchorLeadCorretor = props.dataLead?.idLeadCorretor
    ? props.dataLead?.idLeadCorretor
    : null;

  const steps = [
    "Novo lead",
    "Em contato",
    "Em nutrição",
    "Visita",
    "Em negociação",
    "Comprou",
  ];

  const handleEtapaFunil = (value: string) => {
    switch (value === null ? value : value.toLowerCase()) {
      case "novo lead":
        return 0;
      case "em contato":
        return 1;
      case "em nutrição":
        return 2;
      case "visita":
        return 3;
      case "em negociação":
        return 4;
      case "comprou":
        return 5;
      default:
        return 0;
    }
  };

  const activeStep = handleEtapaFunil(props.dataLead?.etapaLead || "");
  const [etapasOpen, setEtapasOpen] = useState(false);

  function CustomStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    if (completed) {
      // Completed steps
      return (
        <Styles.CustomIconRoot className={className}>
          <FaCheck color="white" size={16} />
        </Styles.CustomIconRoot>
      );
    }
    if (active) {
      // Active step
      return (
        <Styles.CustomIconRoot className={className}>
          <IoRefresh color="white" size={20} />
        </Styles.CustomIconRoot>
      );
    }
    // Upcoming steps
    return (
      <Styles.CustomIconRootAfter className={className}>
        {""}
      </Styles.CustomIconRootAfter>
    );
  }

  const isDisabled =
    props.readOnly ||
    (codigoCargo2013 !== "219.840.002" &&
      codigoCargo2013 !== "219.840.012" &&
      codigoCargo2013 !== "219.840.001");

  return (
    <>
      <Styles.Container>
        <Styles.Row className="steps-row">
          <Styles.Stepper
            activeStep={activeStep}
            isDisabled={isDisabled}
            alternativeLabel
          >
            {steps.map((label, index) => (
              <Step key={label} completed={index < activeStep}>
                <StepLabel StepIconComponent={CustomStepIcon}>
                  <Styles.TextLabel>{label}</Styles.TextLabel>
                </StepLabel>
              </Step>
            ))}
          </Styles.Stepper>
        </Styles.Row>
        {/* Add the button under the stepper */}
        <Styles.ButtonContainer>
          <Styles.ButtonRow>
            {steps.map((label, index) => (
              <div key={index} className="button-placeholder">
                {activeStep === index && (
                  <Styles.Button
                    disabled={isDisabled}
                    onClick={() => {
                      setEtapasOpen(true);
                      setAnchorEtapa({
                        label: props.dataLead?.etapaLead || "",
                        value: props.dataLead?.idEtapaLead || "",
                      });
                      setAnchorSubEtapa({
                        label: props.dataLead?.subEtapaLead || "",
                        value: props.dataLead?.idSubEtapaLead || "",
                      });
                    }}
                  >
                    {props.dataLead?.subEtapaLead || "Sem subetapa"}
                  </Styles.Button>
                )}
              </div>
            ))}
          </Styles.ButtonRow>
        </Styles.ButtonContainer>
        <Styles.Line />
        <DialogCommon
          closeText="Fechar"
          saveText="Salvar"
          onClose={() => setEtapasOpen}
          onSave={() => {}}
          isRight={false}
          onClean={() => {}}
          titleHeader="Atualizar etapa"
          isFilter={false}
          isClose
          width={400}
          component={
            <EtapasModal
              onClose={() => setEtapasOpen(false)}
              open={etapasOpen}
              anchorLeadCorretor={anchorLeadCorretor}
              anchorEtapa={anchorEtapa}
              anchorSubEtapa={anchorSubEtapa}
              refetch={props.refetch}
            />
          }
          setOpenModal={setEtapasOpen}
          open={etapasOpen}
          icon={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#D1FADF",
                border: "8px solid #ECFDF3",
                padding: 2,
                borderRadius: "50%",
                height: 52,
                width: 52,
                marginRight: 12,
              }}
            >
              <IoIosRefresh color="black" size={24} style={{ margin: 0 }} />
            </div>
          }
        />
      </Styles.Container>
    </>
  );
}
